// Skills icons - https://icon-sets.iconify.design/
import { Icon } from "@iconify/react";

// Navbar Logo image (add your image to the src/images directory and uncomment the line below to import your image)
import newLogo from "./images/fork.jpg"

// Hero Images (add your images to the /images directory with the same names)
import HeroLight from "./images/antarctica.png";
import HeroDark from "./images/seo.jpg";

// Projects Images (add your images to the images directory and import below)
import Logo from "./images/logo.svg";

/* START HERE
 **************************************************************
  Add your GitHub username (string - "YourUsername") below.
*/
export const githubUsername = "ItsJuls";

// Navbar Logo image
export const navLogo = newLogo;

/* Main
 ************************************************************** 
  Add a custom blog icon or update the hero images for the Main section.
*/
export const Blog = null;

// Hero images (imported above - lines 8-9)
export { HeroLight as Light };
export { HeroDark as Dark };

/* About Me
 **************************************************************
  Add a second paragraph for the about me section.
*/
export const moreInfo = (
    <>
        You can call me Jules. I'm a Computer Engineering student at{" "}
        <a
            href="https://www.dlsu.edu.ph/"
            target="_blank"
            rel="noopener noreferrer"
        >
            De La Salle University
        </a>{" "}
        and an avid lover of Computer Hardware and its intricacies, somehow more so than software.
        <br/><br/>If you couldn't tell, I like the Honkai series a lot.
        <br/><br/>I have been developing Minecraft Servers for 4+ years and been coding in Java for over 2. I love tinkering with things and figuring out how they work, especially on trying to make them fit to my specifications. Honestly a good way to learn.
        <br/><br/>I first built my own PC when I was 12, since then I've always been fascinated with the electronics and the history behind why they exist and the purpose they serve in our everyday lives. This led me to take up my course which put me in a path of new experiences and fun within a campus far away from my hometown.
        <br/><br/>If you're here for my Earth Maps or any of my code, scroll down below. They're there. I've put effort and love into them, hopefully they'll work for you.
    </>
);

/* Skills
 ************************************************************** 
  Add or remove skills in the SAME format below, choose icons here -
*/
export const skillData = [
    {
        id: 1,
        skill: (
            <a href="https://www.java.com" target="_blank" rel="noopener noreferrer">
                <Icon icon="logos:java" className="display-4" />
            </a>
        ),
        name: (
            <a href="https://www.java.com" target="_blank" rel="noopener noreferrer">
                Java
            </a>
        ),
    },
    {
        id: 2,
        skill: (
            <a href="https://www.jetbrains.com/idea/" target="_blank" rel="noopener noreferrer">
                <Icon icon="logos:intellij-idea" className="display-4" />
            </a>
        ),
        name: (
            <a href="https://www.jetbrains.com/idea/" target="_blank" rel="noopener noreferrer">
                IntelliJ
            </a>
        ),
    },
    {
        id: 3,
        skill: (
            <a href="https://papermc.io/" target="_blank" rel="noopener noreferrer">
                <Icon icon="fa:paper-plane" className="display-4" />
            </a>
        ),
        name: (
            <a href="https://papermc.io/" target="_blank" rel="noopener noreferrer">
                PaperMC
            </a>
        ),
    },
    {
        id: 4,
        skill: (
            <a href="https://github.com/PolyhedralDev/Terra" target="_blank" rel="noopener noreferrer">
                <img src="/Terra.png" alt="Terra" className="display-4" />
            </a>
        ),
        name: (
            <a href="https://github.com/PolyhedralDev/Terra" target="_blank" rel="noopener noreferrer">
                Terra
            </a>
        ),
    },
    {
        id: 5,
        skill: (
            <a href="https://www.docker.com/" target="_blank" rel="noopener noreferrer">
                <Icon icon="logos:docker-icon" className="display-4" />
            </a>
        ),
        name: (
            <a href="https://www.docker.com/" target="_blank" rel="noopener noreferrer">
                Docker
            </a>
        ),
    },
    {
        id: 6,
        skill: (
            <a href="https://pterodactyl.io/" target="_blank" rel="noopener noreferrer">
                <Icon icon="simple-icons:pterodactyl" className="display-4" />
            </a>
        ),
        name: (
            <a href="https://pterodactyl.io/" target="_blank" rel="noopener noreferrer">
                Pterodactyl
            </a>
        ),
    },
    {
        id: 7,
        skill: (
            <a href="https://ubuntu.com/" target="_blank" rel="noopener noreferrer">
                <Icon icon="logos:ubuntu" className="display-4" />
            </a>
        ),
        name: (
            <a href="https://ubuntu.com/" target="_blank" rel="noopener noreferrer">
                Ubuntu
            </a>
        ),
    },
    {
        id: 8,
        skill: (
            <a href="https://git-scm.com/" target="_blank" rel="noopener noreferrer">
                <Icon icon="bi:git" className="display-4" />
            </a>
        ),
        name: (
            <a href="https://git-scm.com/" target="_blank" rel="noopener noreferrer">
                Git
            </a>
        ),
    },
    {
        id: 9,
        skill: (
            <a href="https://github.com/" target="_blank" rel="noopener noreferrer">
                <Icon icon="fa6-brands:square-github" className="display-4" />
            </a>
        ),
        name: (
            <a href="https://github.com/" target="_blank" rel="noopener noreferrer">
                GitHub
            </a>
        ),
    },
];

// Resume link (string - "https://YourResumeUrl") - I am using CloudFront to share my resume (https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/Introduction.html)
export const resume = null;

/* Projects
 ************************************************************** 
  List the repo names (string - "your-repo-name") you want to include (they will be sorted alphabetically). If empty, only the first 3 will be included.
*/
export const filteredProjects = ["example-1", "example-2", "example-3"];

// Replace the defualt GitHub image for matching repos below (images imported above - lines 7-8)
export const projectCardImages = [
  {
    name: "example-1",
    image: Logo,
  },
];

/* Contact Info
 ************************************************************** 
  Add your formspree endpoint below.
  https://formspree.io/
*/
export const formspreeUrl = "https://formspree.io/f/xgvzbgdr";

// Footer icons theme (light or dark)
export const footerTheme = "dark";
